export const MapContainerZIndex = {
  MapAttributions: 80,
  MapComments: 90,
  MapQuickTools: 100,
  RightSidePanel: 999,
  MapPopup: 999,
  MapCommentPopover: 1005
}
